module.exports = __webpack_public_path__ + "static/helvetica-light-06137036ee2d59941c9bda383866b943.otf";